const {Component} = require("react");
const PropTypes = require("prop-types");
const Modal = require("components/modals/Modal");
const {classList} = require("helpers/html");

class SubjectPicker extends Component {

	static get propTypes() {
		return {
			levelsPool: PropTypes.array,
			subjectsPool: PropTypes.array,
			subjects: PropTypes.array,
			handleChange: PropTypes.func,
			selectionMax: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			selectionMax: 3
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			currentLevel: props.levelsPool[0],
			subjects: props.subjects
		};
	}

	componentWillReceiveProps(props) {
		this.setState({
			subjects: props.subjects
		});
	}

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get level() {
		return this.state.currentLevel;
	}

	get subjects() {
		return this.state.subjects;
	}

	isCurrentLevel(level) {
		return this.state.currentLevel && this.state.currentLevel.id === level.id;
	}

	isSelectedSubject(subject) {
		return this.state.subjects.findIndex(sub => sub.id === subject.id) !== -1;
	}

	/////////////////////////////////
	// Listeners                  
	/////////////////////////////////

	levelChangeListener(level) {
		return (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.setState({currentLevel: level});
		};
	}

	subjectToggleListener(subject) {
		return (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.setState(state => {
				const index = state.subjects.findIndex(sub => sub.id === subject.id);

				index === -1 ?
					state.subjects.push(subject) :
					state.subjects.splice(index, 1);

				return state;

			}, this.handleChange);
		};
	}

	onClosePicker = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.modal.close();
	};

	onOpenPicker = () => {
		this.setState({currentLevel: this.props.levelsPool[0]});
	};

	/////////////////////////////////
	// Helpers
	/////////////////////////////////

	handleChange() {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.state.subjects);
		}
	}

	open() {
		return this.modal.open();
	}

	close() {
		return this.modal.close();
	}

	/////////////////////////////////
	// Renderers                  
	/////////////////////////////////


	renderSelection() {
		const selection = this.state.subjects.slice(0, this.props.selectionMax).map(subject => {
			return (
				<span className="subject" key={subject.id}>{subject.name}</span>
			);
		});

		if (this.state.subjects.length > this.props.selectionMax) {
			selection.push(
				<span key="rest" className="rest">+{this.state.subjects.length - this.props.selectionMax}</span>
			);
		}

		return selection;
	}

	renderLevels() {
		return this.props.levelsPool.map(level => {
			const className = classList(
				this.isCurrentLevel(level) && "active"
			);

			return (
				<li key={level.id} className={className} onClick={this.levelChangeListener(level)}>{level.name}</li>
			);
		});
	}

	renderSubjects() {
		const level = this.level;

		return this.props.subjectsPool
			.filter(subject => level.subjects.indexOf(subject.id) !== -1)
			.map(subject => {
				const className = classList(
					this.isSelectedSubject(subject) && "active"
				);

				return (
					<li key={subject.id} className={className} onClick={this.subjectToggleListener(subject)}>{subject.name}</li>
				);
			});
	}

	renderBrowser() {
		return (
			<div className="subjects-browser">

				<div className="levels">
					<ul>{this.renderLevels()}</ul>
				</div>

				<div className="subjects">
					<ul>{this.renderSubjects()}</ul>
				</div>

			</div>
		);
	}

	render() {
		return (
			<Modal ref={el => this.modal = el} handleOpen={this.onOpenPicker} className="subjects-picker">
				<h3 className="modal-title">Vælg fag</h3>

				<div className="subject-selection">
					<span>Udvalgte fag:</span>
					{this.renderSelection()}
				</div>

				{this.renderBrowser()}

				<div className="modal-actions">
					<button type="button" className="btn" onClick={this.onClosePicker}>Luk</button>
				</div>
			</Modal>
		);
	}

}

module.exports = SubjectPicker;


// WEBPACK FOOTER //
// ./resources/js/components/widgets/SubjectPicker.js